import { render, staticRenderFns } from "./BadProductChart.vue?vue&type=template&id=2b7e9ca3&"
import script from "./BadProductChart.vue?vue&type=script&lang=js&"
export * from "./BadProductChart.vue?vue&type=script&lang=js&"
import style0 from "./BadProductChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports